import React from 'react'
import computercoursenadia from "../images/slider 2.jpg";
import bestcomputercentrekrishnagar from "../images/SLIDER NEW.jpg";
import teacherapply from "../images/banner 2.png"


function Slider() {
  return (
    <div>
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>

  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <a href='https://www.asthadigitalservices.com/TeacherForm'>
      <img src={teacherapply} className="d-block w-100" alt="teacherapply"/>
      </a>
    </div>
     <div className="carousel-item">
      <img src={computercoursenadia} className="d-block w-100" alt="computercoursenadia"/>
    </div>
    <div className="carousel-item">
      <img src={bestcomputercentrekrishnagar} className="d-block w-100" alt="computercoursenadia"/>
    </div>
   
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider